/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { createClient } from 'pexels';
import { PEXELS_API_KEY } from '../../../../../../../redux/slices/application/pexels/pexelsModels';
import { ImageList, ImageListItem, InputAdornment, TextField } from '@mui/material';
import { Props } from '../../../../../../../redux/slices/content/contentModels';

import {yupResolver} from '@hookform/resolvers/yup'
import {useForm, SubmitHandler } from 'react-hook-form'
import * as yup from 'yup'
import Swal from 'sweetalert2';
import { KTSVG } from '../../../../../../../../_metronic/helpers';
import { DraggableImage } from '../../../../EditorComponents';
import { Media } from '../../../../../../../redux/slices/media/mediaModels';
import moment from 'moment';
//----------------------------------------

type Query = {
  query: string,
  srcList: string[],
}

const DEFAULT_SRC_LIST = ["pexels"]
// const DEFAULT_SRC_LIST = ["pexels", "unsplash"]

const schema = yup.object().shape({
  query: yup.string().trim().required().min(1).max(100),    
  srcList: yup.mixed().required() 
})

//----------------------------------------
export const SubTabCanva: React.FC<Props> = ({className}) => {
  // const client = createClient(PEXELS_API_KEY);

  // const [selectedSrcList, setSelectedSrcList] = useState<any[]>(DEFAULT_SRC_LIST);

  // const [result, setResult] = useState<any[]>([]);
  // const [resultLandscape, setResultLandscape] = useState<any[]>([]);
  // const [resultPortrait, setResultPortrait] = useState<any[]>([]);
  
  // const [query, setQuery] = useState("");

  // const [loading, setLoading] = useState(false);
  // const [nextPage, setNextPage] = useState(1);
  // const [perPage, setPerPage] = useState(50);

  // console.log("result : ", result)

  // console.log("loading : ", loading)
  // console.log("nextPage : ", nextPage)

  // const { 
  //   register, 
  //   setValue,
  //   handleSubmit,
  //   trigger,
  //   reset,
  //   watch,
  //   setError,
  //   clearErrors,
  //   formState:{
  //       errors,        
  //       isLoading,         
  //       isValid,   
  //       isSubmitting,
  //       isSubmitSuccessful
  //   }
  // } = useForm<Query>({
  //     resolver: yupResolver(schema),
  //     defaultValues:{
  //       query: "",
  //       srcList: DEFAULT_SRC_LIST
  //     }
  // }) 
  
  // ----------------------------------------
  // const viewMoreImages = async () => {
  //   const nextP = nextPage + 1
  //   setLoading(true)
  //   setNextPage(nextP)

  //   try{
  //     let response: any
  //     // ------------------------

  //     if (query.length > 0){
  //       response = await client.photos.search({ query, page: nextP, per_page: perPage });                
  //     }else{
  //       response = await client.photos.curated({ page: nextP, per_page: perPage });        
  //     }

  //     if (response){
  //       let arrKeys = result.map(res => res.id)        
  //       let mergeResults = result

  //       //---reduce the redundant
  //       response.photos.map((ph: any) => {
  //         if (! arrKeys.includes(ph.id)){
  //           arrKeys = [...arrKeys, ph.id]
  //           mergeResults = [...mergeResults, ph]
  //         }
  //       })

  //       if (result.length !== mergeResults.length){
  //         setResult(mergeResults)
  //       }else{
  //         setLoading(false)
  //       }
  //     } 
  //   }catch(error){
  //     setLoading(false)
  //     console.log("error", error)
  //     Swal.fire(
  //         'There is something wrong during the loading!',
  //         'error'
  //     )
  //   }
  // }

  // //---------------------------------------------------- 
  // const formSubmitHandler: SubmitHandler<Query> = async (inputs ) => {
  //   const query = inputs.query
  //   // --------------------

  //   setLoading(true)
  //   setNextPage(1)
  //   setQuery(query)

  //   try{
  //     if (query.length > 0){
  //       const response:any = await client.photos.search({ query, per_page: perPage });
  //       // console.log("submit respon: ", response)

  //       if (response){
  //         setResult(response.photos)
  //       } 
  //     }
  //   }catch(error){
  //     setLoading(false)
  //     console.log("error", error)
  //     Swal.fire(
  //         'There is something wrong during the search!',
  //         'error'
  //     )
  //   }
  // }

  // ---------------------------------
  // useEffect(()=>{
  //   if (result){      
  //     setResultLandscape(result.filter(res => res.width >= res.height))
  //     setResultPortrait(result.filter(res => res.width < res.height))      
  //   }     
  //   setLoading(false)
  // },[result])

  // // ---------------------------------
  // useEffect(()=>{
  //   setNextPage(1)
  //   setLoading(true)
  //   const response:any = client.photos.curated({per_page: perPage }).then((response: any) => {
  //     // console.log("response Image: ", response)
  //     if (response){
  //       setResult(response.photos)
  //       setLoading(false)
  //     } 
  //   })
  // },[])

  //-----------------------------------------
  return (    
      <div 
        className='h-100 w-100 mx-0'
        style={{
          maxHeight:"100%",
          overflowX:"hidden"
          // scrollbarWidth: "thin"
        }}
      >                     
          {/* <form id="frm-edit-query" className='form' onSubmit={handleSubmit(formSubmitHandler)}>  */}
            
          {/* </form> */}
        <div className="mb-3">
          Canva   
          
        </div>
      </div>
   
  )
}

